// export const network = "97";
export const network = "56";

// QUAN TRỌNG: ĐỔI NETWORK THÌ NHỚ IMPORT FILE MYCHAIN56 HOẶC MYCHAIN97 TƯƠNG ỨNG TRONG COMPONENT WALLET CONNECT
